import { registerLocaleData } from '@angular/common';
import localeEnAu from '@angular/common/locales/en-AU';
import { LOCALE_ID, NgModule, ErrorHandler } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';

import { SharedModule } from './shared';
import { Error404Component } from './marketing';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { UnsubscribeComponent } from './clients/auth/unsubscribe';
import { UnsubscribeSucessComponent } from './clients/auth/unsubscribe/unsubscribe-success.component';
import { SentryHandler } from './sentry-handler';

registerLocaleData(localeEnAu);

@NgModule({
  bootstrap: [AppComponent],
  declarations: [
    AppComponent,
    Error404Component,
    UnsubscribeComponent,
    UnsubscribeSucessComponent,
  ],
  imports: [
    AppRoutingModule,
    BrowserModule,
    SharedModule,
  ],
  providers: [
    {
      provide: ErrorHandler,
      useClass: SentryHandler
    },
    {
      provide: LOCALE_ID,
      useValue: 'en-AU',
    },
  ],
})
export class AppModule {}



// WEBPACK FOOTER //
// ./src/app/app.module.ts